/* eslint-disable jsx-a11y/alt-text */
import React, { useState } from 'react'
import {
  Dialog,
  Button,
  Divider,
  Table,
  TableBody,
  TableRow,
  TableCell,
} from '@mui/material'
import Loading from 'app/components/MatxLoading/MatxLoading'
import _ from 'lodash'
import SmilesDataViewer from './SmilesDataViewer'

type SmilesDialogProps = {
  smilesImgUrl: string
  onClose: () => void
  imageWidth: number
  imageHeight: number
  smilesData: any
  columns: any
}
const SmilesDialog: React.FC<SmilesDialogProps> = ({
  smilesImgUrl,
  onClose,
  imageWidth,
  imageHeight,
  smilesData,
  columns,
}) => {
  const [loading, setLoading] = useState(true)

  return (
    <>
      <Dialog open={true} maxWidth="sm" onClose={onClose}>
        <>
          {loading && <Loading />}
          <SmilesDataViewer
            imageWidth={imageWidth}
            imageHeight={imageHeight}
            smilesImgUrl={smilesImgUrl}
            columns={columns}
            smilesData={smilesData}
            setLoading={setLoading}
          />

          <div className="flex justify-center pt-2 m--2">
            <Button
              className="m-2 rounded hover-bg-primary px-6"
              variant="outlined"
              onClick={onClose}
            >
              Close
            </Button>
          </div>
        </>
      </Dialog>
    </>
  )
}

export default SmilesDialog
